module.exports = __webpack_public_path__ + "img/AI辅助设计平台.0046579c.png";